import React from "react";
import Button from "../../../../components/Button/Button";
import StackLayout from "../../../../components/layouts/StackLayout/StackLayout";
import FieldsCollection from "../../../../components/FieldsCollection/FieldsCollection";
import EditableField from "../EditableField/EditableField";
import Validator from "../../../../classes/Validator";
import CheckboxWithName from "../CheckboxWithName/CheckboxWithName";
import Slider from "../../../../components/Slider/Slider";
import * as CobHelpers from "../../Cob.helpers";
import {getPropertiesByPrefix, parseDraftDataPropsToFieldState} from "../../../../helpers/utils";


export default class UboFields extends React.Component
{
    state = _getInitialState.call(this);

    componentDidMount()
    {
        this.props.onChange(this._areUboFieldsValid());
    }

    componentDidUpdate(prevProps, prevState)
    {
        const {props} = this;

        if (prevProps.draftData !== props.draftData)
        {
            if (props.draftData)
            {
                // get the draftData props specific to this section only
                const draftDataProps = getPropertiesByPrefix(props.draftData, ["customer_", "contact_", "checkbox_", "radio_", "kyc_", "company_"]);

                // parse the draftData props into state.fields
                const newFieldsState = parseDraftDataPropsToFieldState(this.state.fields, draftDataProps);
                this.setState(
                    {
                        fields: {...newFieldsState}
                    }
                );
            }
        }
    }

    render()
    {
        const uboRows = [];
        for (let i = 0; i < this.state.numberOfUbos; i++)
        {
            const isCompanyCheckboxName = "company_benowner_iscompany_" + i;
            const firstNameFieldName = "company_benowner_firstname_" + i;
            const lastNameFieldName = "company_benowner_lastname_" + i;
            const ssnFieldName = "company_benowner_ssn_" + i;

            uboRows.push((
                <li key={"ubo-" + i}>
                    <h4>Huvudman {i + 1}</h4>

                    <CheckboxWithName
                        label="Huvudman är juridisk person"
                        name={isCompanyCheckboxName}
                        value={"yes"}
                        checked={this.state.fields[isCompanyCheckboxName].checked}
                        onChange={this._onCheckboxChange}
                    />

                    {this.state.fields[isCompanyCheckboxName].checked && (
                        <React.Fragment>
                            <FieldsCollection
                                fieldsPerRow={3}
                                fields={[
                                    {
                                        render: (
                                            <EditableField
                                                name={firstNameFieldName}
                                                label="Firma"
                                                autocomplete="nope"
                                                value={this.state.fields[firstNameFieldName]}
                                                valid={!this.state.validFields[firstNameFieldName] || this.state.validFields[firstNameFieldName].length === 0 ? null : true}
                                                onChange={this._onFieldChange}
                                            />
                                        )
                                    },
                                    {
                                        render: (
                                            <EditableField
                                                name={ssnFieldName}
                                                label="Organisationsnummer"
                                                autocomplete="nope"
                                                value={this.state.fields[ssnFieldName]}
                                                valid={!this.state.fields[ssnFieldName] || this.state.fields[ssnFieldName].length === 0 ? null : Validator.validateOrgNum(this.state.fields[ssnFieldName])}
                                                onChange={this._onFieldChange}
                                            />
                                        )
                                    }
                                ]}
                            />
                        </React.Fragment>
                    )}

                    {!this.state.fields[isCompanyCheckboxName].checked && (
                        <React.Fragment>
                            <FieldsCollection
                                fieldsPerRow={3}
                                fields={[
                                    {
                                        render: (
                                            <EditableField
                                                name={firstNameFieldName}
                                                label="Förnamn"
                                                autocomplete="nope"
                                                value={this.state.fields[firstNameFieldName]}
                                                valid={!this.state.validFields[firstNameFieldName] || this.state.validFields[firstNameFieldName].length === 0 ? null : true}
                                                onChange={this._onFieldChange}
                                            />
                                        )
                                    },
                                    {
                                        render: (
                                            <EditableField
                                                name={lastNameFieldName}
                                                label="Efternamn"
                                                autocomplete="nope"
                                                value={this.state.fields[lastNameFieldName]}
                                                valid={!this.state.validFields[lastNameFieldName] || this.state.validFields[lastNameFieldName].length === 0 ? null : true}
                                                onChange={this._onFieldChange}
                                            />
                                        )
                                    },
                                    {
                                        render: (
                                            <EditableField
                                                name={ssnFieldName}
                                                label="Personnummer"
                                                autocomplete="nope"
                                                value={this.state.fields[ssnFieldName]}
                                                valid={!this.state.fields[ssnFieldName] || this.state.fields[ssnFieldName].length === 0 ? null : Validator.validateSsn(this.state.fields[ssnFieldName])}
                                                onChange={this._onFieldChange}
                                            />
                                        )
                                    }
                                ]}
                            />
                        </React.Fragment>
                    )}

                    <Slider
                        label="Ägarandel"
                        value={parseInt(this.state.fields["company_benowner_percentage_" + i] || "0", 10)}
                        min={25}
                        unit="%"
                        visibleValues={[0, 25, 50, 75, 100]}
                        onChange={this._onFieldChange.bind(this, "company_benowner_percentage_" + i)}
                    />

                    <input type={"hidden"} name={"company_benowner_percentage_" + i}
                           value={this.state.fields["company_benowner_percentage_" + i]} />
                </li>
            ));
        }

        return (
            <React.Fragment>
                <h4 style={{
                    margin: "40px 0 10px 0",
                    width: "100%",
                    paddingTop: "40px",
                    borderTop: "1px solid #DDD"
                }}>
                    Information om verkliga huvudmän
                </h4>
                <p style={{marginTop: "5px"}}>
                    En fysisk person för vars räkning någon annan person handlar, eller om kunden är en juridisk person,
                    den som utövar ett bestämmande inflytande över kunden.
                </p>

                <StackLayout fullWidth>
                    <Button
                        size="small"
                        label="Ta bort sista"
                        appearance={this.state.numberOfUbos <= 0 ? "medium" : "danger"}
                        disabled={this.state.numberOfUbos <= 0}
                        onClick={() => this.setState({numberOfUbos: this.state.numberOfUbos - 1})}
                    />

                    <Button
                        size="small"
                        label="Lägg till huvudman"
                        appearance={this.state.numberOfUbos >= 4 ? "medium" : "primary"}
                        disabled={this.state.numberOfUbos >= 4}
                        onClick={() => this.setState({numberOfUbos: this.state.numberOfUbos + 1})}
                        filled
                    />
                </StackLayout>

                {this.state.numberOfUbos === 0 && (
                    <React.Fragment>
                        <p style={{
                            fontStyle: "italic",
                            maxWidth: "600px"
                        }}>
                            Om det inte finns någon verklig huvudman enligt ägande (25%) uppge en alternativ verklig
                            huvudman, t.ex. VD eller styrelseordförande.
                        </p>
                        <input type="hidden" name="checkbox_company_nobenowner" value="Ja" />

                        <FieldsCollection
                            fieldsPerRow={3}
                            fields={[
                                {
                                    render: (
                                        <EditableField
                                            name="company_benowner_alt_name"
                                            label="Namn"
                                            autocomplete="nope"
                                            value={this.state.fields.company_benowner_alt_name}
                                            valid={!this.state.validFields.company_benowner_alt_name || this.state.validFields.company_benowner_alt_name.length === 0 ? null : true}
                                            onChange={this._onFieldChange}
                                        />
                                    )
                                },
                                {
                                    render: (
                                        <EditableField
                                            name="company_benowner_alt_ssn"
                                            label="Personnummer"
                                            autocomplete="nope"
                                            value={this.state.fields.company_benowner_alt_ssn}
                                            valid={!this.state.fields.company_benowner_alt_ssn || this.state.fields.company_benowner_alt_ssn.length === 0 ? null : Validator.validateSsn(this.state.fields.company_benowner_alt_ssn)}
                                            onChange={this._onFieldChange}
                                        />
                                    )
                                },
                                {
                                    render: (
                                        <EditableField
                                            name="company_benowner_alt_title"
                                            label="Titel"
                                            autocomplete="nope"
                                            value={this.state.fields.company_benowner_alt_title}
                                            valid={!this.state.validFields.company_benowner_alt_title || this.state.validFields.company_benowner_alt_title.length === 0 ? null : true}
                                            onChange={this._onFieldChange}
                                        />
                                    )
                                }
                            ]}
                        />
                    </React.Fragment>
                )}

                {this.state.numberOfUbos > 0 && (
                    <React.Fragment>
                        <ul className="ubo-fields-list">
                            {uboRows}
                        </ul>
                    </React.Fragment>
                )}

            </React.Fragment>
        );
    }

    _areUboFieldsValid = () =>
    {
        for (let i = 0; i < this.state.numberOfUbos; i++)
        {
            const isCompanyCheckboxName = "company_benowner_iscompany_" + i;
            const firstNameFieldName = "company_benowner_firstname_" + i;
            const lastNameFieldName = "company_benowner_lastname_" + i;
            const ssnFieldName = "company_benowner_ssn_" + i;

            if (this.state.fields[firstNameFieldName].length === 0 ||
                this.state.fields[ssnFieldName].length === 0)
            {
                return false;
            }

            if (!this.state.fields[isCompanyCheckboxName].checked &&
                this.state.fields[lastNameFieldName].length === 0)
            {
                return false;
            }

            if (!this.state.fields[isCompanyCheckboxName].checked &&
                !Validator.validateSsn(this.state.fields[ssnFieldName]))
            {
                return false;
            }
            else if (this.state.fields[isCompanyCheckboxName].checked &&
                !Validator.validateOrgNum(this.state.fields[ssnFieldName]))
            {
                return false;
            }
        }

        if (this.state.numberOfUbos === 0 && (this.state.fields.company_benowner_alt_name.length === 0 ||
            this.state.fields.company_benowner_alt_title.length === 0 ||
            !this.state.fields.company_benowner_alt_ssn ||
            !Validator.validateSsn(this.state.fields.company_benowner_alt_ssn)))
        {
            return false;
        }

        return true;
    };

    _onFieldChange = (name, value) =>
    {
        CobHelpers.onViewFieldChange.call(this, name, value, null, () =>
        {
            this.props.onChange(this._areUboFieldsValid());
        });
    };

    _onCheckboxChange = (name, checked) =>
    {
        this.setState({
            fields: {
                ...this.state.fields,
                [name]: {...this.state.fields[name], checked}
            }
        }, () =>
        {
            this.props.onChange(this._areUboFieldsValid());
        });
    };

    // Internal methods
    _fieldValidator = (name, value) =>
    {
        if (name.indexOf("company_benowner_alt_ssn") > -1 || name.indexOf("company_benowner_ssn_") > -1)
        {
            return Validator.validateSsn(value, false) || Validator.validateOrgNum(value, true);
        }

        return value.length > 0;
    };
}

function _getInitialState()
{
    if (this.props.prevState)
    {
        return {...this.props.prevState};
    }

    const initialState = {
        numberOfUbos: 0,

        fields: {
            company_benowner_alt_name: "",
            company_benowner_alt_ssn: "",
            company_benowner_alt_title: "",

            company_benowner_iscompany_0: {
                checked: false
            },
            company_benowner_firstname_0: "",
            company_benowner_lastname_0: "",
            company_benowner_ssn_0: "",

            company_benowner_iscompany_1: {
                checked: false
            },
            company_benowner_firstname_1: "",
            company_benowner_lastname_1: "",
            company_benowner_ssn_1: "",

            company_benowner_iscompany_2: {
                checked: false
            },
            company_benowner_firstname_2: "",
            company_benowner_lastname_2: "",
            company_benowner_ssn_2: "",

            company_benowner_iscompany_3: {
                checked: false
            },
            company_benowner_firstname_3: "",
            company_benowner_lastname_3: "",
            company_benowner_ssn_3: ""
        },

        validFields: {
            company_benowner_alt_name: "",
            company_benowner_alt_ssn: "",
            company_benowner_alt_title: "",

            company_benowner_firstname_0: "",
            company_benowner_lastname_0: "",
            company_benowner_ssn_0: "",
            company_benowner_percentage_0: true,

            company_benowner_firstname_1: "",
            company_benowner_lastname_1: "",
            company_benowner_ssn_1: "",
            company_benowner_percentage_1: true,

            company_benowner_firstname_2: "",
            company_benowner_lastname_2: "",
            company_benowner_ssn_2: "",
            company_benowner_percentage_2: true,

            company_benowner_firstname_3: "",
            company_benowner_lastname_3: "",
            company_benowner_ssn_3: "",
            company_benowner_percentage_3: true
        }
    };

    const lookupData = this.props.session.lookupData;
    initialState.numberOfUbos = lookupData.ubos.length;
    for (let i = 0; i < lookupData.ubos.length; i++)
    {
        const ubo = lookupData.ubos[i];

        initialState.fields["company_benowner_firstname_" + i] = ubo.firstName;
        initialState.validFields["company_benowner_firstname_" + i] = ubo.firstName.length > 0;
        initialState.fields["company_benowner_lastname_" + i] = ubo.lastName;
        initialState.validFields["company_benowner_lastname_" + i] = ubo.lastName.length > 0;
        initialState.fields["company_benowner_ssn_" + i] = ubo.ssn;

        if (ubo.extent_code === "INTERVALL5")
        {
            initialState.fields["company_benowner_percentage_" + i] = 100;
        }
        else
        {
            initialState.fields["company_benowner_percentage_" + i] = 25;
        }
        initialState.validFields["company_benowner_percentage_" + i] = true;
    }

    if (this.props.draftData !== null)
    {
        const draftDataProps = getPropertiesByPrefix(this.props.draftData, ["customer_", "contact_", "checkbox_", "radio_", "kyc_", "company_"]);

        if (draftDataProps.company_benowner_alt_name && draftDataProps.company_benowner_alt_name.length > 0)
        {
            initialState.validFields["company_benowner_alt_name"] = true;
        }

        if (draftDataProps.company_benowner_alt_title && draftDataProps.company_benowner_alt_title.length > 0)
        {
            initialState.validFields["company_benowner_alt_title"] = true;
        }


        if (draftDataProps.company_benowner_firstname_0 && draftDataProps.company_benowner_firstname_0.length > 0)
        {
            initialState.fields.company_benowner_percentage_0 = ""; // Replaced with draft value in next step
            initialState.validFields["company_benowner_firstname_0"] = true;
            initialState.validFields["company_benowner_lastname_0"] = true;
            initialState.validFields["company_benowner_percentage_0"] = true;
            initialState.numberOfUbos = 1;
        }

        if (draftDataProps.company_benowner_firstname_1 && draftDataProps.company_benowner_firstname_1.length > 0)
        {
            initialState.fields.company_benowner_percentage_1 = ""; // Replaced with draft value in next step
            initialState.validFields["company_benowner_firstname_1"] = true;
            initialState.validFields["company_benowner_lastname_1"] = true;
            initialState.validFields["company_benowner_percentage_1"] = true;
            initialState.numberOfUbos = 2;
        }

        if (draftDataProps.company_benowner_firstname_2 && draftDataProps.company_benowner_firstname_2.length > 0)
        {
            initialState.fields.company_benowner_percentage_2 = ""; // Replaced with draft value in next step
            initialState.validFields["company_benowner_firstname_2"] = true;
            initialState.validFields["company_benowner_lastname_2"] = true;
            initialState.validFields["company_benowner_percentage_2"] = true;
            initialState.numberOfUbos = 3;
        }

        if (draftDataProps.company_benowner_firstname_3 && draftDataProps.company_benowner_firstname_3.length > 0)
        {
            initialState.fields.company_benowner_percentage_3 = ""; // Replaced with draft value in next step
            initialState.validFields["company_benowner_firstname_3"] = true;
            initialState.validFields["company_benowner_lastname_3"] = true;
            initialState.validFields["company_benowner_percentage_3"] = true;
            initialState.numberOfUbos = 4;
        }

        initialState.fields = parseDraftDataPropsToFieldState(initialState.fields, draftDataProps);
    }

    return initialState;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/UboFields/UboFields.js